import React from 'react';
import PropTypes from 'prop-types';

const UiExpandRegionVerticalPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M8 8.795L3.58 4.376a.5.5 0 0 0-.707 0l-.883.884a.5.5 0 0 0 0 .707l5.656 5.657a.498.498 0 0 0 .708 0l5.656-5.657a.5.5 0 0 0 0-.707l-.883-.884a.5.5 0 0 0-.708 0L8 8.796z"
    />
  );
};

UiExpandRegionVerticalPath.propTypes = {
  fill: PropTypes.string,
};

export default UiExpandRegionVerticalPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/ui-controls/ui-expand-region-vertical.jsx